import { SearchParam, SearchParamType } from '@se/platform';

export const parseDate = (dateStr: string | Date | undefined): Date | undefined => {

    if (typeof dateStr === 'string' && dateStr.indexOf('#') !== -1) {
        try {
            const dmy = dateStr.split('#');
            if (dmy.length !== 3) return undefined;
            const day = +dmy[0];
            const month = +dmy[1] - 1;
            const year = +dmy[2];
            return new Date(new Date().getFullYear() + year, new Date().getMonth() + month, new Date().getDate() + day);
        } catch {
            return undefined;
        }
    } else if (dateStr instanceof Date) {
        return dateStr; // If it's already a Date object, return it as is
    } else if (typeof dateStr === 'string') {
        return new Date(dateStr);
    }
    return undefined; // If it's not a string or Date, return undefined
};

export const fixSearchParam = (searchParam: SearchParam) => {
    if (searchParam.property.type === SearchParamType.fromTo) {
        const { from, to } = searchParam.property.value;

        searchParam.property.value.from = parseDate(from);
        searchParam.property.value.to = parseDate(to);
    }

    return searchParam;
};

export const fixSearchParams = (searchParams: SearchParam[]) => searchParams.map(fixSearchParam);

export const paramsDateReviver = (value: {
    from: string | Date | undefined;
    to: string | Date | undefined;
}) => {

    let from = undefined;
    let to = undefined;

    if (typeof value.from === 'string' && value.from.indexOf('#') !== -1) {
        try {
            let fromDMY = (<string>value.from).split('#');
            let fromD = +fromDMY[0];
            let fromM = +fromDMY[1];
            let fromY = +fromDMY[2];

            from = new Date(
                new Date().getFullYear() + fromY,
                new Date().getMonth() + fromM,
                new Date().getDate() + fromD,
            );
        } catch {
            from = undefined;
        }
    }

    if (typeof value.to === 'string' && value.to.indexOf('#') !== -1) {
        try {
            let toDMY = (<string>value.to).split('#');
            let toD = +toDMY[0];
            let toM = +toDMY[1];
            let toY = +toDMY[2];

            to = new Date(
                new Date().getFullYear() + toY,
                new Date().getMonth() + toM,
                new Date().getDate() + toD,
            );
        } catch {
            to = undefined;
        }
    }

    if (from || to) {
        value.from = from;
        value.to = to;
    }

    return value;
};
